import { useCallback, useEffect, useState } from 'react';

import { apiClient } from '@/services/legacy-api';
import { Team } from '@/types';

export function useTeams() {
  const [teams, setTeams] = useState<Team[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchTeams = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await apiClient.getTeams();
      setTeams(data);
      return data;
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to fetch teams');
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    // The mount fetch reports through the hook's `error` state —
    // rethrowing here would surface as an unhandled rejection.
    fetchTeams().catch(() => {});
  }, [fetchTeams]);

  return { teams, isLoading, error, fetchTeams };
}
